export default function stopEventBubbling(e) {
  e.cancelBubble = true
  if (e.stopPropagation) {
    e.stopPropagation()
  }
}